import providerNames from './providerNames';

const creditRiskProviderNameChoices = [
  { id: providerNames.CREDITSAFE, name: 'Creditsafe' },
  { id: providerNames.FILE_BASED, name: 'File Based' },
];

export default creditRiskProviderNameChoices;
